/**
 * Slovenian catalog (Latin) for the Phase 2 `MessageId` set — Agent 9, batch 2.
 *
 * `dir: 'ltr'`. Native-grade Slovenian at a mathematician's register. **Warrant → «Utemeljitev»**
 * (justification — flagged). Slovenian keeps the DUAL: CLDR cardinal categories are one / two /
 * few / other, with «omejitev» declined (1 omejitev · 2 omejitvi · 3–4 omejitve · 5+ omejitev),
 * so `frameActive` declares exactly those (plus an explicit `=0`). Per INV-STABLE-ID a wrong
 * translation is a presentation concern only — every verdict stays fixed.
 */
import { P2 } from '../message-ids-phase2.js';
export const SL_CATALOG = {
    locale: 'sl',
    dir: 'ltr',
    messages: {
        [P2.inquiryTitle]: 'Raziskava',
        [P2.sectionClaims]: 'Trditve',
        [P2.sectionIntegrity]: 'Celovitost',
        [P2.axisWarrantLabel]: 'Utemeljitev',
        [P2.axisWarrantValue]: 'W{w, number, ::numbering-system/latn}',
        [P2.axisEmpiricalLabel]: 'Empirično',
        [P2.axisEmpiricalValue]: '{kind, select, defn {Definicija} interp {Razlaga} testable {Preverljivo} tested {Preverjeno} refuted {Ovrženo} program {Raziskovalni program} philos {Filozofsko} other {Neznano}}',
        [P2.axisModalLabel]: 'Modalno',
        [P2.axisModalValue]: 'M{m, number, ::numbering-system/latn}',
        [P2.axisKidSummary]: 'Raven moči {w, number, ::numbering-system/latn}',
        [P2.stateExplorable]: 'Raziskljivo',
        [P2.stateRefuted]: 'Ovrženo',
        [P2.stateOutside]: 'Zunaj obsega',
        [P2.verdictConflict]: 'V nasprotju z {constraints}',
        [P2.verdictOutside]: 'Zahteva {missing}',
        [P2.lossRegisterPlain]: 'Poenostavljeno v vsakdanji jezik — del natančnosti je izpuščen.',
        [P2.lossRegisterKid]: 'Poenostavljeno za mlajše bralce — mnogo podrobnosti je izpuščenih.',
        [P2.lossProfileDetail]: 'Celoten profil Utemeljitev / Empirično / Modalno je povzet tukaj.',
        [P2.lossConflictDetail]: 'Podrobnosti spora so v tem pogledu skrajšane.',
        [P2.laneVerified]: 'Preverjeno',
        [P2.laneUnverified]: 'Nepreverjeno',
        [P2.laneConflict]: 'Spor dokazan',
        [P2.constraintLogic]: 'Logika',
        [P2.constraintLightBends]: 'Svetloba se ukrivi v gravitacijskem polju',
        [P2.constraintParallelPostulate]: 'Postulat o vzporednicah',
        [P2.claimScalarGravity]: 'Skalarna teorija gravitacije',
        [P2.claimNonEuclidean]: 'Neevklidska geometrija',
        [P2.claimSubstrateSr]: 'Substratna razlaga posebne relativnosti',
        [P2.edgeExtObservation]: 'Zunanje opazovanje',
        [P2.edgeResourceSample]: 'Deljeni računski vir',
        [P2.edgeHeuristicSample]: 'Hevristično vodilo',
        [P2.edgeSharedSample]: 'Skupni temelj',
        // --- Phase 2 view-chrome ---
        [P2.sectionConstraints]: 'Omejitve',
        [P2.sectionEdges]: 'Povezave',
        [P2.sectionFrame]: 'Okvir',
        [P2.sectionExposure]: 'Izpostavljenost',
        [P2.statusAdoptedFormal]: 'Sprejeto (formalno)',
        [P2.statusAdoptedInterpretive]: 'Sprejeto (interpretativno)',
        [P2.statusSuspended]: 'Začasno ustavljeno',
        [P2.edgeEffectConstraint]: 'Tvori omejitev (lahko ovrže)',
        [P2.edgeEffectResource]: 'Vir — brez učinka na sodbe',
        [P2.edgeEffectHeuristic]: 'Hevristika — brez učinka na sodbe',
        [P2.edgeEffectShared]: 'Skupni temelj — brez učinka na sodbe',
        [P2.frameActive]: '{count, plural, =0 {Ni aktivnih omejitev} one {# aktivna omejitev} two {# aktivni omejitvi} few {# aktivne omejitve} other {# aktivnih omejitev}}',
        [P2.exposureNone]: 'Brez interpretativnih odvisnosti',
        [P2.exposureDep]: 'Odvisno od {id}',
        [P2.laneTrackMachine]: 'Stroj',
        [P2.laneTrackExpert]: 'Strokovnjak',
        [P2.laneTrackCommunity]: 'Skupnost',
        [P2.expertAudited]: 'Revidirano',
        [P2.expertInProgress]: 'V teku',
        [P2.expertNotReviewed]: 'Ni pregledano',
        [P2.communityFlags]: 'Oznake obstajajo',
        [P2.communityNone]: 'Ni oznak',
        [P2.controlChallenge]: 'Izpodbijaj',
        [P2.controlActivate]: 'Aktiviraj',
        [P2.controlMakeInterpretive]: 'Naredi interpretativno',
        [P2.controlImportEdge]: 'Uvozi povezavo',
        [P2.controlPromote]: 'Povišaj',
        [P2.controlUndo]: 'Razveljavi',
        [P2.controlRedo]: 'Uveljavi',
        [P2.controlRegister]: 'Registriraj',
        [P2.promoteRejected]: 'Povišanje zavrnjeno',
        [P2.promoteAccepted]: 'Povišanje sprejeto',
        [P2.promoteReasonRefutationTerminal]: 'Dokaz ne more pozdraviti ovržbe.',
        [P2.promoteReasonKeystone]: 'Ključno povišanje zahteva empirično podporo.',
        [P2.promoteReasonEmpiricalNotFixed]: 'Empirična vrsta ni določena.',
        [P2.promoteReasonModalNotFixed]: 'Modalna stopnja ni določena.',
        [P2.promoteReasonWarrantNotImproved]: 'Stopnja utemeljitve se ni izboljšala.',
        [P2.evidenceComputation]: "{engine} je izračunal {op} = {result} pri {config}",
        [P2.lossNumericRounding]: "Rezultat zaokrožen na {dp} decimalnih mest",
    },
};
//# sourceMappingURL=sl.js.map